export const news = {
    'news.title': '{title} - News | R.Toys',
    'news.default': 'News',
}
